import { MarkdownRenderer } from '#core/components/shared/MarkdownRenderer.tsx';

import classes from './StreamingMarkdown.module.css';

// Static configuration hoisted to module scope so that consumers (and
// react-markdown's internal child cache) see referentially stable values
// across re-renders. Recreating these per render — especially during
// 5-10 Hz streaming — defeats memoization downstream.

interface MarkdownTextProps {
  /** Markdown source. Pass through assistant-ui's `Text` component override (`AssistantBubble`). */
  text: string;
}

/**
 * Renders streaming message markdown content with Mantine-styled headings, tables, and dividers.
 */
export function StreamingMarkdown({ text }: MarkdownTextProps) {
  return <MarkdownRenderer className={classes.markdownText} content={text} />;
}
